import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './category-faq.component.scss';
var CategoryFaq = /** @class */ (function (_super) {
    tslib_1.__extends(CategoryFaq, _super);
    function CategoryFaq(element) {
        return _super.call(this, element) || this;
    }
    CategoryFaq.prototype.init = function () { };
    CategoryFaq.prototype.bindEvents = function () { };
    return CategoryFaq;
}(Base));
export { CategoryFaq };



//////////////////
// WEBPACK FOOTER
// ./components/category-faq/category-faq.component.ts
// module id = 198
// module chunks = 0